/**
 * List Schema of AuditoriaObservacao
 * @author Simpli CLI generator
 */
import {
  Helper,
  Schema,
  FieldSet,
  FieldComponent,
  Component,
} from 'simpli-web-sdk'
import {AuditoriaObservacao} from '@/model/resource/AuditoriaObservacao'

/* TODO: review generated schema */
export class ListAuditoriaObservacaoSchema extends Schema {
  readonly name = 'ListAuditoriaObservacao'

  readonly fieldSet: FieldSet<AuditoriaObservacao> = {
    idObservacaoPk: (): FieldComponent => ({
      is: Component.Render,
    }),
    carga: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.carga?.$id,
      },
    }),
    responsavel: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.responsavel?.$id,
      },
    }),
    texto: (): FieldComponent => ({
      is: Component.Render,
    }),
    dataEnvio: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.datetime(schema.model.dataEnvio),
      },
    }),
  }
}
